import { Injectable } from '@angular/core';
import { Firestore, addDoc, collection, collectionData, doc, docData, deleteDoc, updateDoc, DocumentReference, setDoc} from '@angular/fire/firestore';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GroupService {

  constructor(private firestore: Firestore,) { }

  addEditGroup(data: any, id:string) {
    let collectionRef = 'groups';
    if(!id) {
      id = doc(collection(this.firestore, collectionRef)).id;
    }
    collectionRef = `groups/${id}`;
    const groupRef = doc(this.firestore, collectionRef);
    return setDoc(groupRef, data);
  }

  getGroup(){
    const groupRef = collection(this.firestore, `groups`);
    return collectionData(groupRef, {idField: 'id'}) as Observable<any>;
  }

  deleteGroup(id:string) {
    const groupDel = doc(this.firestore, `groups/${id}`);
    return deleteDoc(groupDel);
  }

  getOrganization(){
    const studentRef = collection(this.firestore, `organisations`);
    return collectionData(studentRef, {idField: 'id'}) as Observable<any>;
  }

}
